import { render, staticRenderFns } from "./AgreementTerms.vue?vue&type=template&id=837f578c&scoped=true&"
import script from "./AgreementTerms.vue?vue&type=script&lang=js&"
export * from "./AgreementTerms.vue?vue&type=script&lang=js&"
import style0 from "./AgreementTerms.vue?vue&type=style&index=0&id=837f578c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837f578c",
  null
  
)

export default component.exports